__webpack_require__.p = "/firechat/";